import { Card, Flex, type MantineTheme } from '@mantine/core';
import type { IconNames } from '@repo/foundations';
import { Icon, Text } from '@repo/foundations';
import { memo } from 'react';

export const AiImpactWidgetEmpty = memo(
	({
		theme,
		message,
		icon,
	}: {
		theme: MantineTheme;
		message: string;
		icon: IconNames;
	}) => (
		<Card h={280} style={{ borderRadius: theme.radius.md }} p={0}>
			<Flex
				h="100%"
				direction="column"
				align="center"
				justify="center"
				py="xl"
				gap="sm"
			>
				<Icon name={icon} size="lg" color="text/secondary/default" />
				<Text color="text/secondary/default" size="sm">
					{message}
				</Text>
			</Flex>
		</Card>
	)
);
